/**
 * Launch an application on Android platform
 * @param {Object} app The app object containing app_id and other properties
 * @returns {boolean} Success status of the launch
 */
export const launchApp = (app) => {
  try {
    if (!window.Android) {
      console.error("Android bridge not available");
      return false;
    }

    return window.Android.launchApp(app.app_id);
  } catch (error) {
    console.error("Error launching Android app:", error);
    return false;
  }
};
